/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Page_Meta_TitleInputs */

const en_agents_page_meta_title = /** @type {(inputs: Agents_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents | Glider`)
};

const de_agents_page_meta_title = /** @type {(inputs: Agents_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenten | Glider`)
};

const pt_br2_agents_page_meta_title = /** @type {(inputs: Agents_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes | Glider`)
};

const tr_agents_page_meta_title = /** @type {(inputs: Agents_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajanlar | Glider`)
};

const zh_cn2_agents_page_meta_title = /** @type {(inputs: Agents_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理 | Glider`)
};

const zh_hk2_agents_page_meta_title = /** @type {(inputs: Agents_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理 | Glider`)
};

const ko_kr2_agents_page_meta_title = /** @type {(inputs: Agents_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에이전트 | Glider`)
};

const ru_ru2_agents_page_meta_title = /** @type {(inputs: Agents_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Агенты | Glider`)
};

const es_419_agents_page_meta_title = /** @type {(inputs: Agents_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes | Glider`)
};

/**
* | output |
* | --- |
* | "Agents \| Glider" |
*
* @param {Agents_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const agents_page_meta_title = /** @type {((inputs?: Agents_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agents_page_meta_title(inputs)
	if (locale === "de") return de_agents_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_agents_page_meta_title(inputs)
	if (locale === "tr") return tr_agents_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_agents_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_agents_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_agents_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_agents_page_meta_title(inputs)
	return es_419_agents_page_meta_title(inputs)
});